module.exports = __webpack_public_path__ + "media/src/images/icons/check-1f464577b85eaaf206b6456ea4b1948d.svg";